import LocalStorageHelper from "../helpers/LocalStorageHelper";
import { RestHelper } from "../helpers/RestHelper";
import { enumLocalStorageArgs } from "../helpers/common.constants";

export class TaskService {
  private _restHelper;

  constructor() {
    this._restHelper = new RestHelper();
  }


  async Edit(payload: any) {
    const url: string = "Task/Edit";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async EditWithCheck(payload: any) {
    const url: string = "Task/EditWithCheck";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  

  async Save(payload: any) {
    const url: string = "Task/Save";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async NewTaskByTemplate(payload: any) {
    const url: string = "Task/NewTaskByTemplate";
    let response = await this._restHelper.post(url, payload);
    return response;
  }


  async Submit(payload: any) {
    const url: string = "Task/Submit";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async VerifierAnswer(payload: any) {
    const url: string = "Task/VerifierAnswer";
    let response = await this._restHelper.post(url, payload);
    return response;
  }



  async ApproverAnswer(payload: any) {
    const url: string = "Task/ApproverAnswer";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  
  async Delete(payload: any) {
    const url: string = "Task/Delete";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async RecreationSearch(payload: any) {
    const url: string = "Task/RecreationSearch";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  
  async Search(payload: any) {
    const url: string = "Task/Search";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async Validate(payload: any) {
    const url: string = "Task/Validate";
    let response = await this._restHelper.post(url, payload);
    return response;
  }

  async UploadDocuments(payload: any) {
    const url: string = "Task/UploadDocuments";
    let response = await this._restHelper.post2Files(url, payload);
    return response;
  }

  
}
